// import ProductService from '@/services/ProductService.js'
// export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

import CartService from "@/services/CartService"
import Vue from 'vue'

export const state = {
  cart: [],
  products: []
}

export const mutations = {
  addToCart(state, item) {
    let found = state.cart.find(
      product => product.product_Id == item.product_Id
    )

    if (found) {
      found.productQuantity++
    } else {
      state.cart.push(item)
    }
  }
}

export const actions = {
  getFromCart({ dispatch }) {
    return CartService.getFromCart()
        .then(response => {
            const notification = {
                type: 'success',
                message: 'Your cart has been fetched successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            return response.data
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem fetching your carts: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },
  addToCart({ dispatch }, cartItems) {
    return CartService.addToCart(cartItems)
        .then(() => {
            const notification = {
                type: 'success',
                message: 'Your new cart item has been added successfully!'
            }
            dispatch('notification/add', notification, { root: true })
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem adding your cart item: ' + error.message
            }
            if(error.response && error.response.data) {
                Vue.notify({
                    group: 'main',
                    type: 'error',
                    text: error.response.data.message
                  });
            }
            dispatch('notification/add', notification, { root: true })
            // throw error
        })
  },
  updateStock({ dispatch }, cartItems) {
    return CartService.updateStock(cartItems)
        .then(() => {
            const notification = {
                type: 'success',
                message: 'Stock has been updated successfully!'
            }
            dispatch('notification/add', notification, { root: true })
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem updating stock: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },
  checkStock({ dispatch }, unitProductData) {
    return CartService.checkStock(unitProductData.unit_id, unitProductData.product_id, unitProductData.quantity)
        .then(response => {
            return response.data
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem checking the stock: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },
  removeFromCart({ dispatch }, cartItemId) {
    return CartService.removeFromCart(cartItemId)
        .then(() => {
            const notification = {
                type: 'success',
                message: 'Your new cart item has been removed successfully!'
            }
            dispatch('notification/add', notification, { root: true })
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem removing your cart item: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  }
}

export const getters = {}
